// Общие анимации админки (framer-motion).

// Переход между страницами (используется в AnimatedOutlet):
// новая страница въезжает справа из прозрачности, старая уходит вниз и гаснет.
export const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0, transition: { duration: 0.28, ease: "easeOut" } },
  exit: { opacity: 0, y: 30, transition: { duration: 0.2, ease: "easeIn" } },
};

// Плавное «всплывание» блока снизу с прозрачностью (карточки дашборда).
export const itemVariants = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.35, ease: "easeOut" } },
};